var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIndustrious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.0225,
    cy: 12.1367,
    r: 9.5,
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9116 6.81357L14.2278 6.40957C14.2805 6.33931 14.3156 6.26905 14.3859 6.19879C14.3156 6.05827 14.2629 5.90018 14.1576 5.72453C13.9468 5.67183 13.7887 5.65427 13.613 5.6367C13.5779 5.70696 13.5076 5.77723 13.4725 5.84749L13.1563 6.25149L12.8402 6.65548L12.6996 6.83114C13.0334 6.86627 13.3496 6.98922 13.6482 7.18244L13.9116 6.81357ZM16.8802 12.5925C16.4059 11.5737 15.3871 10.7482 14.8602 10.555C14.7899 8.412 13.5252 7.62157 12.2956 7.62157H12.0322H11.7687C10.5391 7.62157 9.292 8.412 9.20417 10.5725C8.69478 10.7657 7.676 11.6791 7.18418 12.6979C6.62209 13.8748 6.81531 16.369 6.85044 16.6149L6.88557 17.2824H8.57183C9.80139 17.2824 10.1878 16.0529 10.3108 15.157C10.6796 15.8948 11.2769 17.0365 11.8038 18.2134L12.0146 18.6525L12.2254 18.1607C12.7523 17.0014 13.3496 15.9299 13.7184 15.1746C13.8414 16.0704 14.2102 17.3 15.4574 17.3H17.1436L17.1788 16.5974C17.2315 16.2988 17.4247 13.7869 16.8802 12.5925ZM9.39739 13.9275C9.39739 15.28 9.16905 16.0529 8.60696 16.0529H7.86922C7.83409 15.2097 7.85166 13.8748 8.15026 13.2424C8.37861 12.7682 8.72992 12.2061 9.02852 11.925L9.27444 13.2951L9.39739 13.9275ZM11.7863 8.69305H12.0497H12.3132C13.0158 8.69305 13.736 9.06191 13.8765 10.3793H12.0673H10.2405C10.381 9.06191 11.0836 8.69305 11.7863 8.69305ZM12.0497 16.2461C11.8214 15.684 11.4876 15.2097 11.2769 14.7179H12.8402C12.5943 15.2097 12.2781 15.684 12.0497 16.2461ZM13.8765 11.8196C13.8414 12.1885 13.7536 12.9087 13.6657 13.26H10.4162C10.3459 12.8911 10.2581 12.1709 10.2054 11.8196H13.8765ZM16.2302 16.0529H15.5101C14.948 16.0529 14.7196 15.28 14.7196 13.9275L14.8426 13.26L15.0885 11.9075C15.3871 12.1885 15.7384 12.7506 15.9668 13.2424C16.2478 13.8748 16.2654 15.2097 16.2302 16.0529ZM10.1703 6.81357L10.4337 7.14731C10.7323 6.95409 11.0485 6.83114 11.3823 6.79601L11.2417 6.62035L10.9256 6.23392L10.6094 5.82992C10.5567 5.75966 10.504 5.70697 10.4689 5.61914C10.3108 5.63671 10.1351 5.65427 9.92435 5.70697C9.81896 5.90018 9.7487 6.04071 9.696 6.19879C9.76626 6.26905 9.80139 6.32175 9.85409 6.40957L10.1703 6.81357Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.522461,
    y: 0.636719,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIndustrious);
export default __webpack_public_path__ + "static/media/pin_industrious.6a81a0758fab4430bbfebd858ccf3e45.svg";
export { ForwardRef as ReactComponent };